var map = {
	"./new_spotd1.gif": "c202",
	"./new_spotd10.gif": "8fa4",
	"./new_spotd11.gif": "7c34",
	"./new_spotd2.gif": "c2fe",
	"./new_spotd3.gif": "fce0",
	"./new_spotd4.gif": "efb3",
	"./new_spotd5.gif": "2eb8",
	"./new_spotd6.gif": "abce",
	"./new_spotd7.gif": "3d84",
	"./new_spotd8.gif": "32f0",
	"./new_spotd9.gif": "5d46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a396";